import { createBrowserRouter } from 'react-router';

import { GameStream } from '@/pages/game-stream';
import { RootPage } from '@/pages/root';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootPage,
  },
  {
    path: '/game-stream/:gameId',
    Component: GameStream,
  },
]);
